'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dragHandle = require('./drag-handle');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_dragHandle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-beautiful-dnd/lib/view/drag-handle/index.js
// module id = 3059
// module chunks = 0